import { ProductCategory } from './product-category.model';

export class MeterPointSelection {
  id: string;
  category: ProductCategory;
  meterPointNumber: string;
  meterNumber: string;
  contractNumber: string;
  meterCount: string;
}

export const SELECTED_METER_POINT_PRODUCTS = 'selectedMeterPointProducts';
